import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';

import css from '@webapp/account/src/components/survey/results/applied-filters/applied-filters.css';
import type { IFilterGroup } from '@webapp/account/src/resources/reports';
import { Actions } from '@webapp/account/src/resources/reports';
import { removeFilterGroup } from '@webapp/account/src/resources/reports/async-filters';
import { deleteShareLink, getShareLinks } from '@webapp/account/src/resources/survey';
import { selectSurveys } from '@webapp/account/src/resources/survey/selectors';

import { RemoveBtn } from '@webapp/common/assets/icons/remove';
import { ConfirmRemovePopup } from '@webapp/common/components/popups/confirm-remove-popup';
import { useActions } from '@webapp/common/hooks/use-actions';

export const FilterGroups: FC<{
    filterGroups: Array<IFilterGroup>;
    surveyId: number;
}> = ({ filterGroups, surveyId }) => {
    const [removeGroupId, setRemoveGroupId] = useState(null);

    const { shareLinks, shareLinksSurveyId } = useSelector(selectSurveys);

    const updateAllFilters = useActions(Actions.updateAllFilters);
    const removeFilterGroupRequest = useActions(removeFilterGroup);
    const getShareLinksRequest = useActions(getShareLinks);
    const deleteShareLinkRequest = useActions(deleteShareLink);

    useEffect(() => {
        if (typeof removeGroupId === 'number' && shareLinksSurveyId !== surveyId) {
            getShareLinksRequest(surveyId);
        }
    }, [removeGroupId, surveyId, shareLinksSurveyId, getShareLinksRequest]);

    const shareLinksWithFilterGroup = useMemo(() => {
        return shareLinks.filter((item) => item.filterGroupId === removeGroupId);
    }, [shareLinks, removeGroupId]);

    return (
        <div className={css.filterGroupsWrap}>
            {filterGroups.map(({ name, id, data }) => {
                const compareCount = Array.isArray((data as any)?.comparePeriods)
                    ? (data as any).comparePeriods.length
                    : 0;

                return (
                    <div key={id} className={css.filterGroup}>
                        <a
                            className='link'
                            onClick={() => {
                                updateAllFilters(data);
                            }}
                        >
                            {name}
                            {compareCount > 0 ? ` (сравнение: ${compareCount})` : ''}
                        </a>
                        <RemoveBtn
                            onClick={() => {
                                setRemoveGroupId(id);
                            }}
                        />
                    </div>
                );
            })}
            {typeof removeGroupId === 'number' && (
                <ConfirmRemovePopup
                    title='Удалить группу фильтров?'
                    visible={true}
                    onAccept={() => {
                        removeFilterGroupRequest(removeGroupId);

                        shareLinksWithFilterGroup.forEach((item) => {
                            deleteShareLinkRequest(item.id);
                        });
                    }}
                    onClose={() => {
                        setRemoveGroupId(null);
                    }}
                >
                    {shareLinksWithFilterGroup.length > 0 && (
                        <div>
                            При удалении группы фильтров{' '}
                            {shareLinksWithFilterGroup.length === 1
                                ? 'будет удалена публичная ссылка'
                                : 'будут удалены публичные ссылки'}{' '}
                            на результаты:{' '}
                            {shareLinksWithFilterGroup.map((item, i, arr) => {
                                return (
                                    <>
                                        <b>{item.title}</b>
                                        {i + 1 !== arr.length && ', '}
                                    </>
                                );
                            })}
                            , т.к. в {shareLinksWithFilterGroup.length === 1 ? 'ней' : 'них'} используется группа
                            фильтров.
                        </div>
                    )}
                </ConfirmRemovePopup>
            )}
        </div>
    );
};
